import { Icon } from '../ui/Icon';
import { Button } from '../ui/primitives';
import type { CommercialNoticeModel } from '../../utils/billingView';

interface CommercialNoticeProps {
  notice: CommercialNoticeModel;
  onOpenBilling: () => void;
}

/**
 * ONB-007 (Macrofase B) — el aviso global de facturación, encima de cada pantalla. Solo aparece cuando el
 * acceso está en riesgo ahora (solo lectura o pago pendiente); lo que dice lo decide `commercialNotice`.
 * No tapa nada ni saca a nadie de la pantalla: consultar sigue funcionando.
 */
export function CommercialNotice({ notice, onOpenBilling }: CommercialNoticeProps) {
  return (
    <div className="n3-billing-notice" role="status">
      <span aria-hidden="true" className="n3-billing-notice__icon"><Icon name="info" size={20} /></span>
      <div className="n3-billing-notice__text">
        <p className="n3-billing-notice__title">{notice.title}</p>
        <p className="n3-billing-notice__body">{notice.text}</p>
      </div>
      {notice.cta && (
        <Button className="n3-billing-notice__action" onClick={onOpenBilling} variant="primary">
          {notice.cta}
        </Button>
      )}
    </div>
  );
}
